export function StatusCard({
  title,
  value,
  color,
  tooltip,
  className = "",
  onNumberClick,
  percentage = undefined,
  delayed,
}: {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  color?: string;
  tooltip?: string;
  className?: string;
  onNumberClick?: (status?: string) => void;
  percentage?: number;
  delayed?: boolean
}) {
  return (
    <div
      className={`
        bg-white shadow-md rounded-xl p-3 border w-full flex flex-col 
        items-center relative transition-transform duration-200 
        hover:-translate-y-1 hover:shadow-lg cursor-pointer ${className}
        ${delayed ? "animate-pulse font-semibold animate-pulse-color" : ""}
      `}
      style={{ willChange: "transform" }}
    >
      <div className="flex flex-col items-center w-full h-10 justify-start">
        <p className="text-gray-500 text-[20px] font-bold text-center leading-tight capitalize">
          {title.toLowerCase()}
        </p>
        <div className="flex items-center">
          {tooltip && (
            <p className="text-[14px] text-locavibe text-center leading-tight">
              {tooltip}
            </p>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={() => onNumberClick?.()}
        className={`mt-2 text-2xl font-bold bg-transparent ${color} ${onNumberClick ? "hover:underline focus:underline outline-none" : ""}`}
        aria-label={`Abrir detalhes de ${title}`}
      >
        {typeof value === "number" ? value.toLocaleString("pt-BR") : value}
      </button>
      {percentage !== undefined && (
        <div className="absolute bottom-2">
          <span
            className={
              "bg-gray-500 text-locavibe text-xs font-bold px-2 py-1 rounded"
            }
          >
            {percentage.toFixed(2)}%
          </span>
        </div>
      )}
    </div>
  );
}
